var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialStudies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ca552b",
    d: "M 132.976562 92.332031 L 105.785156 92.332031 C 101.820312 92.332031 98.421875 95.730469 98.421875 99.695312 L 98.421875 276.144531 C 98.421875 280.109375 101.820312 283.507812 105.785156 283.507812 L 132.976562 283.507812 C 136.941406 283.507812 140.339844 280.109375 140.339844 276.144531 L 140.339844 99.980469 C 140.339844 95.730469 136.941406 92.332031 132.976562 92.332031 Z M 135.242188 122.070312 L 103.519531 122.070312 L 103.519531 117.257812 L 135.242188 117.257812 Z M 135.242188 122.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca552b",
    d: "M 179.425781 92.332031 L 152.234375 92.332031 C 148.269531 92.332031 144.871094 95.730469 144.871094 99.695312 L 144.871094 276.144531 C 144.871094 280.109375 148.269531 283.507812 152.234375 283.507812 L 179.425781 283.507812 C 183.390625 283.507812 186.789062 280.109375 186.789062 276.144531 L 186.789062 99.980469 C 186.789062 95.730469 183.390625 92.332031 179.425781 92.332031 Z M 181.691406 122.070312 L 149.96875 122.070312 L 149.96875 117.257812 L 181.691406 117.257812 Z M 181.691406 122.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca552b",
    d: "M 275.71875 267.363281 L 230.402344 96.863281 C 229.269531 92.898438 225.304688 90.632812 221.339844 91.484375 L 195 98.5625 C 191.035156 99.695312 188.769531 103.660156 189.621094 107.625 L 234.933594 278.125 C 236.066406 282.089844 240.035156 284.355469 244 283.507812 L 270.339844 276.425781 C 274.304688 275.292969 276.570312 271.328125 275.71875 267.363281 Z M 200.382812 127.734375 L 199.25 123.203125 L 229.835938 114.992188 L 230.96875 119.523438 Z M 200.382812 127.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialStudies);
export default __webpack_public_path__ + "static/media/Social Studies.908637d95cd4150746cfa44ca56bfe75.svg";
export { ForwardRef as ReactComponent };